export const CONNECTAD_PROBE = {
  enabled: false,
  dbUrl: "",
  sampleRate: 1,
};

export function connectadIsTarget(url: string): boolean {
  return typeof url === "string" && url.indexOf("i.connectad.io") !== -1 && url.indexOf("/api/v2") !== -1;
}

export function isConnectad(o: any): boolean {
  if (!o) return false;
  const code = o.bidderCode || o.bidder;
  return code === "connectad" || code === "connectadrealtime";
}

export function safeKey(s: any): string {
  return String(s == null ? "na" : s).replace(/[^A-Za-z0-9_-]+/g, "_").slice(0, 40);
}
